import { buildCategoryFilters } from '../../FilterPills/helpers';

export const quickFilterTracking = (
	facetId: string,
	label: string,
	categorySlug: string,
	trackVendors: (filters: Filters.CategoryFilters, action: string) => void,
) => {
	const selectedFilterOptions: Search.AppliedFilterPillProps[] = [
		{
			id: facetId,
			name: label,
			value: label,
			categorySlug,
		},
	];

	const stagedFilters = {
		add: selectedFilterOptions,
		remove: [],
		commitChanges: true,
	} as Search.StagedFilterPills;

	const appliedCategoryFilters = buildCategoryFilters([], stagedFilters);

	trackVendors(appliedCategoryFilters, 'save selected filters');
};
